// extracted by mini-css-extract-plugin
export default {"goTop":"scrolltoTop_goTop__ylCPS","inactive":"scrolltoTop_inactive__9gmDA"};